import type { PuzzleTypeModule } from "./types";

/**
 * In-memory registry of puzzle types. The core only ever talks to a type through this module
 * (CLAUDE.md §7.4, §12): never import `src/puzzle-types/<type>/**` from `src/core`.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyModule = PuzzleTypeModule<any, any, any, any, any>;

const registry = new Map<string, AnyModule>();

export function registerPuzzleType<D, S, P, Sol = unknown, Pr = unknown>(
  module: PuzzleTypeModule<D, S, P, Sol, Pr>,
): void {
  if (registry.has(module.key)) {
    throw new Error(`puzzle type "${module.key}" is already registered`);
  }
  registry.set(module.key, module as AnyModule);
}

export function getPuzzleType(key: string): AnyModule | undefined {
  return registry.get(key);
}

export function listPuzzleTypes(): AnyModule[] {
  return [...registry.values()];
}

export type {
  PuzzleTypeModule,
  PlayerProps,
  EditorProps,
  SolutionEditorProps,
  Feedback,
  PlayerPresence,
  PresencePeer,
  Verdict,
} from "./types";
